import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /inspections */
export const inspectionsRoutes: RouteObject = {
  path: 'inspections',
  handle: handle('inspectionsRequests'),
  lazy: () => import('./InspectionsPage').then((m) => ({ Component: m.InspectionsPage })),
};
